import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatDate } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import TypingBox from '../components/TypingBox';

export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";
  const [ chatRoomId, setChatRoomId ] = useState(props.chatRoomId);
  const [ chatRoomData, setChatRoomData ] = useState(null);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  const scrollToBottom = () => {
    try {
      document.getElementById('_msgsContainer').scrollTo({
        bottom: 0,
        behavior: "smooth"
      });
    } catch (e) {

    }
  }

  const handleChatRoomDataChange = (newData) => {
    setChatRoomData(oldData => {
      if(oldData && newData) {
        if(JSON.parse(newData.messages).length > JSON.parse(oldData.messages).length) {
          scrollToBottom();
        }
      } else {
        //just scroll to bottom directly
        scrollToBottom();
      }
      return newData;
    })
  }

  const getChatRoomData = () => {
    return new Promise(async resolve => {
      if(!ready) setLoading(true);
      await callApi('get_chatroom_data.php', { chatRoomId }).then(response => {
        if(!ready) setLoading(false);
        if(response.status === 1) {
          handleChatRoomDataChange(response.chatRoomData);
          resolve(response.chatRoomData);
        } else {
          appContext.tellError(response.msg)
        }
      })
    })
  }

  const backgroundTasks = async () => {
    //place all functions to run in background here
    await getChatRoomData().then(response => {
      //..
    })
  }

  const submitText = (text) => {
    return new Promise(async resolve => {
      await callApi('submit_text_message.php', { text, chatRoomId }).then(response => {
        if(response.status === 1) {
          getChatRoomData();
          resolve(true);
        } else {
          resolve(false);
          appContext.tellError(response.msg);
        }
      })
    })
  }

  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    await getChatRoomData().then(() => {
      setReady(true);

    })

    //set background tasks

  }


  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
      let intervalId = setInterval(() => {
        backgroundTasks();
      }, appContext.refreshInterval);

      return () => {
        clearInterval(intervalId);
      }
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  useEffect(() => {
    setChatRoomId(props.chatRoomId);
  }, [ props.chatRoomId ]);

  useEffect(() => {
    getChatRoomData();
  }, [ chatRoomId ]);

  if(ready) {
    return (
      <>
        <TopBar title={chatRoomData.title}/>
        <div className="FullPane" id="_msgsContainer" data-support-top-bar={true} data-support-typing-box={true}>
        
          {
            (JSON.parse(chatRoomData.messages).length > 0) ?
            JSON.parse(chatRoomData.messages).map((item, i) => {
              return (
                <div
                  key={i}
                  className="text-start font-light"
                  style={{
                    padding: "10px",
                    margin: "10px",
                    borderRadius: "10px",
                    border: "2px solid var(--faintBlack)",
                    background: (item.id === appContext.userData.id) ? "inherit" : "var(--faintBlack)",
                  }}
                >
                  <h6 className="text-goldish font-bold" style={{ textTransform:"capitalize" }}>{item.username}</h6>
                  {item.text}
                  <div className="text-end">
                    <small className="text-muted">{formatDate(item.time)}</small>
                  </div>
                </div>
              )
            }) : <small>No text messages were found</small>
          }
        </div>
        <TypingBox submitter={submitText}/>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
